module.exports = __webpack_public_path__ + "3988e7dc4d312874eb8633ec40d440d4.png";